<template>
  <div style="background-color: #f5f6fa; height: 100%;    display: flex;
    flex-direction: column;">
    <hear></hear>
    <div class="content">
      <div style class="fl justify-content align-items">
        <Notice></Notice>
        <Guarantee></Guarantee>
      </div>
    </div>
<binad></binad>
  </div>
</template>
<script>
import hear from ".././../components/hear.vue";
import binad from ".././../components/dinad.vue";
import Notice from "./Notice.vue";
import Guarantee from "./Guarantee.vue";
import {} from "@/api/system/liucheng.js"
export default {
  components: {
    hear,
    Notice,
    Guarantee,
    binad
  },
  name: "index",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
element.style {
  flex: 1 !important;
}

.fl {
  display: flex;
  /* justify-content: center; */
  width: 100%;
  /* width: 100%; */
  padding: 0 12%;
}

.content {
  width: 100%;
  /* min-height: calc(100vh - 132px); */
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}

.justify-content {
  justify-content: center;
}

.align-items {
  align-items: center;
}


</style>


// WEBPACK FOOTER //
// src/view/index/index.vue